<template>
  <div class="ClassReport">
    <div class="select">
      <a-select class="option" placeholder="筛选年级" style="width: 120px" @change="handleChangeGrade" allowClear>
        <a-select-option v-for="item in schoolGrades" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-select class="option" placeholder="筛选班级" style="width: 120px" @change="handleChangeClass" allowClear>
        <a-select-option v-for="item in classChangeList" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
    </div>
    <div class="reortTable">
      <a-table :columns="columns" :dataSource="reportInfo" :rowKey="row => row.ID" :pagination="{ pageSize: 10 }" :locale="{emptyText: '该任务不包含班级报告'}">
        <template slot="GRADE" slot-scope="text">{{text}}</template>
        <template slot="CLASS" slot-scope="text">{{text}}</template>
        <div slot="PROGRESS" slot-scope="text, record" style="width: 365px">
          <a-progress :percent="parseFloat(record.PROGRESS)" :strokeWidth="6" />
        </div>
        <template slot="operation" slot-scope="text, record">
          <div style="color: #1890FF; cursor: pointer;" @click="getReportUrl(record)">查看报告</div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import STUDENTFUN from '@/util/studentFun'
  import GRADENEW from '@/util/gradeNew'
  // import GRADEYEAR from '@/util/gradeYear'
  import URL from '@/store/url'
  export default {
    name: 'ClassReport',
    data () {
      return {
        columns: [
        {
          title: '年级',
          dataIndex: 'GRADE',
          key: 'GRADE',
          scopedSlots: { customRender: 'ENTRYYEAR' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS',
          key: 'CLASS',
          scopedSlots: { customRender: 'CLASS' }
        },
        {
          title: '报告完成度',
          dataIndex: 'PROGRESS',
          key: 'PROGRESS',
          width: '65%',
          scopedSlots: { customRender: 'PROGRESS' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
        ],
        keyInfo: null,
        reportInfo: [],
        reportInfoAll: [],
        gradeVal: null,
        classVal: null,
        gradeClassAll: null,
        gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初一年级', '初二年级', '初三年级', '高一年级', '高二年级', '高三年级', '大学一年级', '大学二年级', '大学三年级', '大学四年级']
      }
    },
    computed: {
      ...mapState([
        'schoolGrades',
        'classReport',
        'teacherAdmin',
        'taskReport'
      ]),
      classChangeList () {
        let list = null
        if (this.gradeVal) {
          this.gradeClassAll.classMaps.forEach((val, key) => {
            if (this.gradeVal === GRADENEW(key).gradeListSimple) {
              list = val
            }
          })
        } else {
          // console.log(this.gradeClassAll)
          if (this.gradeClassAll) {
            list = this.gradeClassAll.classArr
          } 
        }
        return list
      }
    },
    methods: {
      ...mapActions([
        'getClassReport'
      ]),
      handleChangeGrade(value) {
        this.gradeVal = value
      },
      handleChangeClass(value) {
        this.classVal = value
      },
      getReportUrl(record){
        console.log(this.taskReport)
        const url = `${URL.TO_CLASS_REPORT}?dq_id=${this.taskReport.qid}&school_id=${this.teacherAdmin.school_id}&grade_id=${record.GRADE_ID}&class_id=${record.CLASS_ID}&token=${this.teacherAdmin.tokenValue}&uid=${this.teacherAdmin.uid}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&starttime=${this.taskReport.start_time}&endtime=${this.taskReport.end_time}&schoolName=${this.teacherAdmin.school_name}` 
        if (record.FINISH >= 30) {
          window.open(url)
        } else {
          this.$confirm({
            title: '报告数据未满30人',
            content: '未满30人的报告数据不具有团体代表性，请谨慎参考，确定要继续查看吗？',
            okText: '继续查看',
            cancelText: '取消',
            onOk: () => {
              window.open(url)
            }
          })
        }
      },
      searchHandle(){
        this.reportInfo = this.reportInfoAll.filter((item) => !this.gradeVal ? true : item.GRADE === this.gradeVal).filter((item) => !this.classVal ? true : item.CLASS === this.classVal)
      }
    },
    async mounted () {
      let class_list = JSON.parse(sessionStorage.getItem('userInfo')).class_list
      if (JSON.parse(sessionStorage.getItem('userInfo')).role_id === 3) { // 班主任
        if (class_list && class_list.length) {
          await this.getClassReport()
          if (this.classReport) {
            this.classReport.map((item,index) =>{
              if (item.FINISH !== 0) { // 班级中至少有一个人完成才可以出班级报告
                let report = {
                  ID: index,
                  GRADE: GRADENEW(item.GRADE_ID).gradeListSimple,
                  CLASS: `${item.CLASS_ID}班`,
                  GRADE_ID: item.GRADE_ID,
                  CLASS_ID: item.CLASS_ID,
                  PROGRESS: parseInt((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100) == parseFloat((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100) ? (parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100 : ((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100).toFixed(2),
                  FINISH: parseInt(item.FINISH)
                }
                this.reportInfo.push(report)
                this.reportInfoAll.push(report)
              }
            })
            this.gradeClassAll = STUDENTFUN.uploadClass(this.reportInfoAll)
          }
        }
      } else { // 其他权限角色
        await this.getClassReport()
        if (this.classReport) {
          this.classReport.map((item,index) =>{
            if (item.FINISH !== 0) { // 班级中至少有一个人完成才可以出班级报告
              let report = {
                ID: index,
                GRADE: GRADENEW(item.GRADE_ID).gradeListSimple,
                CLASS: `${item.CLASS_ID}班`,
                GRADE_ID: item.GRADE_ID,
                CLASS_ID: item.CLASS_ID,
                PROGRESS: parseInt((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100) == parseFloat((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100) ? (parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100 : ((parseInt(item.FINISH) / parseInt(item.TOTAL)) * 100).toFixed(2),
                FINISH: parseInt(item.FINISH)
              }
              this.reportInfo.push(report)
              this.reportInfoAll.push(report)
            }
          })
          this.gradeClassAll = STUDENTFUN.uploadClass(this.reportInfoAll)
        }
      }
    },
    watch: {
      taskReport () {
        console.log(12345)
      }
    }
  }
</script>

<style>
.ClassReport .select{
  display: flex;
  margin-left: 40px;
  padding: 24px 0px;
}
.ClassReport .select .ant-btn-primary{
  width:64px;
  height:32px;
  background: rgba(81,191,148,1);
  border-radius: 4px;
  border-color: rgba(81,191,148,1);
}
.ClassReport .select .option{
  width: 120px;
  margin-right: 16px;
}
.ClassReport .select > input{
  width: 180px;
  height: 32px;
  margin-right: 14px;
}
.ClassReport .select .ant-btn > span {
  color: #ffffff;
}
.ant-modal-confirm .ant-modal-confirm-btns button + button {
  background: #51BF94;
  border-color: #51BF94;
  color: #FFFFFF;
}
.ClassReport .ant-table-thead > tr > th, .ClassReport .ant-table-tbody > tr > td {
  padding: 16px 40px!important;
}
</style>